import { useState, useEffect } from 'react';
import { Outlet, useOutletContext } from "react-router-dom";
import axios from 'axios';
import PartnersDetail from './PartnersDetail';
import FullPageLoader from "./FullPageLoader";

const AccountDetail = () => {
    const [searchParams, changeRoute, userid, isUserID, isHistory, isIDDetail, id, options, baseURL] = useOutletContext();  

    const initialECommerceList = [
        {
            code: 'gopay',
            displayName: 'Gopay',
            icon: './images/gopay_icon_3.png',
            iconWidth: '80px',
            category: 'E-Wallet',
            dataKey: 'gopay_data',
            formatting: {
                accounts: {
                    fields: {},
                    isHidden: true
                },
                transactions: {
                    fields: {
                        date: value => {
                            const newValue = new Date(value).toLocaleTimeString("en-us", options);
                            return newValue == 'Invalid Date' ? value : newValue;
                        },
                        // date_width: '100px',
                        // description_width: '150px'
                    },
                    
                },
                locations: {
                    fields: {
                        created_at: value => {
                            const newValue = new Date(value).toLocaleTimeString("en-us", options);
                            return newValue == 'Invalid Date' ? value : newValue;
                        },
                        visit_dates: value => {
                            const newValue = value.split(',').map(value => new Date(value).toLocaleTimeString("en-us", options));
                            if(newValue == 'Invalid Date'){
                                return value;
                            }
                            return (
                                <>
                                {
                                    newValue.map(value => <p key={value} className='dates-block'>{value}</p>)
                                }
                                </>
                            );
                        },
                        // created_at_width: '160px',
                        // visit_dates_width: '160px',
                        // address_width: '400px',
                        // landmark_width: '150px'
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/phone.svg', name: 'Phone', value: 'NA'}, 
                            {icon: './images/credited.svg', name: 'Credited', value: 'NA'},
                        ],
                        [
                            {icon: './images/email.svg', name: 'Email', value: 'NA'}, 
                            {icon: './images/balance.svg', name: 'Balance', value: 'NA'},
                            {icon: './images/debited.svg', name: 'Debited', value: 'NA'}
                        ],
                        [
                            {icon: './images/email.svg', name: 'Email Verified', value: 'NA'},
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                if(!tables['accounts'] || !(tables['accounts'].rows && tables['accounts'].rows.length)){
                    return [];
                }
                
                let accounts = tables['accounts'].rows[0];
                    
                const obj = {...this.partnerInfo[0]};
                obj.table = obj.table.map(row => {
                    return row.map(column => {
                        return {...column};
                    });
                });

                obj.table[0][0].value = accounts['customer_name'];
                obj.table[0][1].value = accounts['number'];
                obj.table[0][2].value = accounts['total_amount_credited'];
                obj.table[1][0].value = accounts['customer_email'];
                obj.table[1][1].value = accounts['balance'];
                obj.table[1][2].value = accounts['total_amount_debited'];
                obj.table[2][0].value = accounts['email_verified'];
                
                return [obj];
            },
            isPartnerInfoShowing: true,
            getErrorMessage(status){
                let mapping = {
                    'Invalid shop url, please check!': 'Invalid shop url',
                    'Authorization mail sent': 'Authorization Incomplete',
                    'Shop is not an Official Store or a Power Merchant. Only Official stores or Power Merchants can be authorized.': 'Shop is not an Official Store or a Power Merchant',
                    'Otp sent successfully': 'Authorization Incomplete',
                    'Invalid OTP. Please try again': 'Invalid OTP Input',
                    'OTP code is expired. Please resend the code': 'OTP Expired',
                    'Too many attempts. Please try again after 15 minutes': 'Authorization Incomplete',
                    'Incorrect phone number. Please enter the registered phone number': 'Unregistered GoPay Number',
                    'OTP timeout, please retry after 30 minutes!': 'Authorization Incomplete',
                };
                return status in mapping ? mapping[status] : 'Authorization Incomplete';
            },
            data: [],
        },
        {
            code: 'multi_bank_ocr',
            displayName: 'Multi Bank',
            icon: './images/multi_bank_ocr.png',
            iconWidth: '36px',
            category: 'Bank E-statement Upload',
            dataKey: 'multi_bank_ocr',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'];
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'];
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            // summaryExcelConfig(selectedId){
            //     return {
            //         method: 'POST',
            //         baseURL,
            //         url: `/bank/analysis`,
            //         params: {
            //             apikey: searchParams.get('apikey'),
            //             id: this.data[selectedId].id,
            //         },
            //         headers: { 
            //             'accept': 'application/json'
            //         }
            //     }
            // },
            // timeOutStatement:90,
            // summarygetExcelConfig(selectedId){
            //     return {
            //         method: 'GET',
            //         baseURL,
            //         url: `/bank/analysis/statement`,
            //         params: {
            //             apikey: searchParams.get('apikey'),
            //             id: this.data[selectedId].id,
            //             bank_name: 'multi_bank_ocr',
            //         },
            //         headers: { 
            //             'accept': 'application/json'
            //         }
            //     }
            // },
            // moduleExcelConfig(selectedId){
            //     return {
            //         method: 'POST',
            //         baseURL,
            //         url: `/bank/analysis/modules`,
            //         params: {
            //             apikey: searchParams.get('apikey'),
            //             id: this.data[selectedId].id,
            //         },
            //         headers: { 
            //             'accept': 'application/json'
            //         }
            //     }
            // }
        },
        {
            code: 'bca',
            displayName: 'BCA',
            icon: './images/BCA_2.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'bca',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'];
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'];
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BCA'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BCA',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'bca',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'telco',
            displayName: 'Telco',
            icon: './images/Telco-Logo.png',
            iconWidth: '80px',
            category: 'Telco',
            dataKey: 'telco_data',
            formatting: {},
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/phone.svg', name: 'Number', value: 'NA'}, 
                            {icon: './images/network.svg', name: 'Provider', value: 'NA'}, 
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                if(!tables['phone'] || !(tables['phone'].rows && tables['phone'].rows.length)){
                    return [];
                }
                
                let accounts = tables['phone'].rows[0];
                    
                const obj = {...this.partnerInfo[0]};
                obj.table = obj.table.map(row => {
                    return row.map(column => {
                        return {...column};
                    });
                });
                
                let number = accounts['number'];
                
                if(number.slice(0, 4) === '+620'){
                    number = '+62-' + number.slice(4);
                }
                else if(number.slice(0, 3) === '620'){
                    number = '+62-' + number.slice(3);
                }
                else if(number.slice(0, 3) === '+62'){
                    number = '+62-' + number.slice(3);
                }
                else if(number.slice(0, 2) === '62'){
                    number = '+62-' + number.slice(2);
                }
                else if(number.slice(0, 2) === '+0'){
                    number = '+62-' + number.slice(2);
                }
                else if(number.slice(0, 1) === '0'){
                    number = '+62-' + number.slice(1);
                }

                obj.table[0][0].value = number;
                obj.table[0][1].value = accounts['provider'];
                
                return [obj];
            },
            isPartnerInfoShowing: true,
            getErrorMessage(status){
                let mapping = {
                    'Unsupported attachment, only CSV or an Excel document is allowed.': 'Unsupported document, only CSV or an Excel document is allowed'
                };
                return status in mapping ? mapping[status] : ( status ? status : undefined );
            },
            data: [],
        },
        {
            code: 'mandiri',
            displayName: 'Mandiri',
            icon: './images/Mandiri_2.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'mandiri',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'MANDIRI'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'MANDIRI',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'mandiri',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'bri',
            displayName: 'BRI',
            icon: './images/BRI_2.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'bri',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BRI'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BRI',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'bri',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'bni',
            displayName: 'BNI',
            icon: './images/BNI_1.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'bni',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BNI'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BNI',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'bni',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'ocbc',
            displayName: 'OCBC',
            icon: './images/OCBC.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'ocbc',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'OCBC'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'OCBC',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'ocbc',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'cimb',
            displayName: 'CIMB',
            icon: './images/CIMB.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'cimb',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'CIMB'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'CIMB',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'cimb',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'permata',
            displayName: 'PERMATA',
            icon: './images/PermataBank.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'permata',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'PERMATA'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'PERMATA',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'permata',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'danamon',
            displayName: 'DANAMON',
            icon: './images/DanamonLogo.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'danamon',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'DANAMON'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'DANAMON',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'danamon',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'btn',
            displayName: 'BTN',
            icon: './images/BTNLogo.png',
            iconWidth: '80px',
            category: 'Bank E-statement Upload',
            dataKey: 'btn',
            formatting: {
                'Account': {
                    fields: {
                        // Address_width: '400px',
                        // 'Account Holder name_width': '150px'
                    },
                },
                Analysis: {
                    fields: {},
                    isHidden: true,
                    transformTable(table){
                        const headers = { 'Account number': null, 'Account Holder name': null, 'Address': null, 'Period': null, 'Type': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            if(obj[1]['Account number']){
                                rows.push({ 
                                    'Account number': obj[1]['Account number'],
                                    'Account Holder name': obj[1]['Account Holder name'], 
                                    'Address': obj[1]['Address'], 
                                    'Period': obj[1]['Period'], 
                                    'Type': obj[1]['Type'] 
                                });
                            }
                        });
                        return { headers, rows };
                    },
                },
                'Credits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                },
                'Debits Overview': {
                    fields: {},
                    transformTable(table){
                        const headers = { 'Name': null, 'Transaction amount': null, 'Transaction count': null };
                        const rows = [];
                        Object.entries(table).forEach(obj => {
                            rows.push({
                                'Name': obj[1]['Name'], 
                                'Transaction amount': obj[1]['Transaction amount'], 
                                'Transaction count': obj[1]['Transaction count']
                            });
                        });
                        return { headers, rows };
                    },
                }
            },
            partnerInfo: [
                {
                    tableName: 'Account',
                    table: [
                        [
                            {icon: './images/account-type.svg', name: 'Account Type', value: 'NA'}, 
                            {icon: './images/bank-name.svg', name: 'Name', value: 'NA'}, 
                            {icon: './images/period.svg', name: 'Period', value: 'NA'}, 
                        ],
                        [
                            {icon: './images/bank-office.svg', name: 'Bank Office', value: 'NA'},
                            {icon: './images/account-no.svg', name: 'Account No.', value: 'NA'},
                            {icon: './images/address.svg', name: 'Address', value: 'NA'}
                        ]
                    ]
                }
            ],
            getPartnerInfo(tables){
                let rows;
                if(!tables['Account'] || !('Account number' in tables['Account'].headers)){
                    if(tables['Analysis'] && 'Account number' in tables['Analysis'].headers && tables['Analysis'].rows.length){
                        rows = tables['Analysis'].rows;
                    }
                    else{
                        return [];
                    }
                }
                else{
                    rows = tables['Account'].rows;
                }

                let accounts = rows.reduce((prev, curr) => {
                    if(curr['Account number'] in prev){
                        prev[curr['Account number']].push(curr);
                    }
                    else{
                        prev[curr['Account number']] = [curr];
                    }
                    return prev;
                }, {});
                accounts = Object.keys(accounts).map((key, index) => {
                    const obj = {...this.partnerInfo[0]};
                    obj.tableName = `Account ${index + 1}`;
                    obj.table = obj.table.map(row => {
                        return row.map(column => {
                            return {...column};
                        });
                    });

                    let period = accounts[key].map(account => account['Period'] && account['Period'].split(' ')[1]).sort();
                    period = period[0] != period[period.length - 1] ? `${period[0]}-${period[period.length - 1]}` : ( period[0] ? period[0] : 'NA' );
                    
                    obj.table[0][0].value = accounts[key][0]['Type'] || 'NA';
                    obj.table[0][1].value = accounts[key][0]['Account Holder name'];
                    obj.table[0][2].value = period;
                    obj.table[1][0].value = 'NA';
                    obj.table[1][1].value = key;
                    obj.table[1][2].value = accounts[key][0]['Address'] || 'NA';
                    
                    return obj;
                })
                return accounts;
            },
            isPartnerInfoShowing: true,
            isBanking: true,
            getErrorMessage(status){
                return status ? status : 'Token available';
            },
            data: [],
            summaryExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BTN'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            timeOutStatement:60,
            summarygetExcelConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/bank/analysis/statement`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'BTN',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            moduleExcelConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/bank/analysis/modules`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        bank_name: 'btn',
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            }
        },
        {
            code: 'shopee',
            codeAgg: 'shopee_agg',
            displayName: 'Shopee',
            icon: './images/shopee_3.png',
            iconWidth: '80px',
            category: 'E-Commerce',
            dataKey: 'shopee_data',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowRefreshButton: true,
            isShowDeleteButton: true,
            isShowSummaryButton: true,
            timeOutRefresh: 61,
            timeOutSummary: 31,
            refreshDataConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/shopee/refresh`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            summaryDataConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/summary/data`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        platform: 'shopee'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            deleteDataConfig(selectedId){
                return {
                    method: 'DELETE',
                    baseURL,
                    url: `/connect/consent/revoke`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
        },
        {
            code: 'shopeeverifybank',
            displayName: 'Shopee Verification',
            icon: './images/shopee_3.png',
            iconWidth: '80px',
            category: 'Bank Verification',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'tokopedia_api',
            codeAgg:'tokopedia_agg',
            displayName: 'Tokopedia',
            icon: './images/tokopedia_3.png',
            iconWidth: '80px',
            category: 'E-Commerce',
            dataKey: 'shop_data',
            formatting: {
                'shipment_info': {
                    fields: {},
                    isHidden: true
                },
                'showcase_info': {
                    fields: {},
                    isHidden: true
                },
                'product_info': {
                    fields: {},
                    isHidden: true
                },
                'saldo_info': {
                    fields: {},
                    isHidden: true
                },
                'bank_info': {
                    fields: {},
                    isHidden: true
                },
                'success': {
                    fields: {},
                    isHidden: true
                },
            },
            partnerInfo: [],
            data: [],
            isShowRefreshButton: true,
            isShowDeleteButton: true,
            isShowSummaryButton: true,
            timeOutRefresh: 61,
            timeOutSummary: 31,
            refreshDataConfig(selectedId){
                return {
                    method: 'POST',
                    baseURL,
                    url: `/tokopedia/refresh`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            summaryDataConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/summary/data`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        platform: 'tokopedia'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            deleteDataConfig(selectedId){
                return {
                    method: 'DELETE',
                    baseURL,
                    url: `/connect/consent/revoke`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            getErrorMessage(status){
                let mapping = {
                    'Invalid shop url, please check!': 'Invalid shop url',
                    'Authorization mail sent': 'Authorization Incomplete',
                    'Shop is not an Official Store or a Power Merchant. Only Official stores or Power Merchants can be authorized.': 'Shop is not an Official Store or a Power Merchant',
                    'Otp sent successfully': 'Authorization Incomplete',
                    'Invalid OTP. Please try again': 'Invalid OTP Input',
                    'OTP code is expired. Please resend the code': 'OTP Expired',
                    'Too many attempts. Please try again after 15 minutes': 'Authorization Incomplete',
                    'Incorrect phone number. Please enter the registered phone number': 'Unregistered GoPay Number',
                    'OTP timeout, please retry after 30 minutes!': 'Authorization Incomplete',
                };
                return status ? ( status in mapping ? mapping[status] : status ) : 'Authorization Incomplete';
            },
        },
        {
            code: 'lazada',
            codeAgg:'lazada_agg',
            displayName: 'Lazada',
            icon: './images/lazada_icon_3.png',
            iconWidth: '80px',
            category: 'E-Commerce',
            dataKey: 'lazada_data',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowSummaryButton: true,
            isShowDeleteButton: true,
            timeOutSummary: 31,
            summaryDataConfig(selectedId){
                return {
                    method: 'GET',
                    baseURL,
                    url: `/summary/data`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id,
                        platform: 'lazada'
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
            deleteDataConfig(selectedId){
                return {
                    method: 'DELETE',
                    baseURL,
                    url: `/connect/consent/revoke`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
        },
        {
            code: 'blibli',
            displayName: 'Blibli',
            icon: './images/blibli_5.png',
            iconWidth: '80px',
            category: 'E-Commerce',
            dataKey: 'blibli_data',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
            isShowDeleteButton: true,
            isCheckExcel: true,
            deleteDataConfig(selectedId){
                return {
                    method: 'DELETE',
                    baseURL,
                    url: `/connect/consent/revoke`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
        },
        {
            code: 'tiktok',
            displayName: 'Tiktok',
            icon: './images/tiktok.png',
            iconWidth: '80px',
            category: 'E-Commerce',
            dataKey: 'tiktok_data',
            isShowDeleteButton: true,
            formatting: {},
            partnerInfo: [],
            data: [],
            deleteDataConfig(selectedId){
                return {
                    method: 'DELETE',
                    baseURL,
                    url: `/connect/consent/revoke`,
                    params: {
                        apikey: searchParams.get('apikey'),
                        id: this.data[selectedId].id
                    },
                    headers: { 
                        'accept': 'application/json'
                    }
                }
            },
        },
        {
            code: 'xero',
            displayName: 'Xero',
            icon: './images/xero_4.png',
            iconWidth: '80px',
            category: 'Accounting & POS',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'jurnal',
            displayName: 'Jurnal',
            icon: './images/jurnal_icon_3.png',
            iconWidth: '80px',
            category: 'Accounting & POS',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'accurate',
            displayName: 'Accurate',
            icon: './images/accurate_icon_1.png',
            iconWidth: '80px',
            category: 'Accounting & POS',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'quickbooks',
            displayName: 'Quickbooks',
            icon: './images/quickbooks_icon_1.png',
            iconWidth: '80px',
            category: 'Accounting & POS',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'mokapos',
            displayName: 'Mokapos',
            icon: './images/mokapos_icon_2.png',
            iconWidth: '80px',
            category: 'Accounting & POS',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'google_location',
            displayName: 'Google Location',
            icon: './images/location_4.png',
            iconWidth: '80px',
            category: 'Social',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
            isCheckExcel: true,
        },
        {
            code: 'instagram',
            displayName: 'Instagram',
            icon: './images/instagram_icon_3.png',
            iconWidth: '80px',
            category: 'Social',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'bankverification',
            displayName: 'Bank Verification',
            icon: './images/bank-verification_3.png',
            iconWidth: '40px',
            category: 'Bank Verification',
            formatting: {},
            partnerInfo: [],
            data: [],
            isShowOnlyDownload: true,
        },
        {
            code: 'identity',
            displayName: 'E-KYC',
            icon: './images/bank-verification_3.png',
            iconWidth: '40px',
            category: 'E-KYC',
            formatting: {},
            partnerInfo: [],
            data: []
        }
    ];

    const [eCommerceList, setECommerceList] = useState(initialECommerceList);
 
    const [isUserIDFetched, setIsUserIDFetched] = useState();

    const [isUserIDError, setIsUserIDError] = useState();

    const [userIDData, setUserIDData] = useState();

    const [userIDAccountDetail, setUserIDAccountDetail] = useState();

    const [isLoading, setLoader] = useState(false);

    const [isShowExcelDownload, setIsShowExcelDownload] = useState();

    const getUserIDData = async () => {
        setLoader(true);
        try{
            const config = {
                method: 'GET',
                baseURL,
                url: '/backoffice/',
                params: {
                    apikey: searchParams.get('apikey'),
                    developer_email: searchParams.get('developer_email'),
                    app_id: searchParams.get('app_id'),
                    limit: 100,
                    user_id: userid
                },
                headers: { 
                    'accept': 'application/json'
                }
            };
            let response = await axios(config);
            response = response.data;

            response.forEach(data => {
                data.connected_partners.forEach(partner => {
                    let connectedPartner = partner;
                    let connectionName;
                    let errorMessage;
                    let fileName;
                    if(Array.isArray(partner)){
                        connectedPartner = partner[0];
                        connectionName = partner[1];
                        errorMessage = partner[2];
                        if(partner[2] == 'File uploaded successfully'){
                            const array = partner[3].split('/');
                            fileName = array[array.length - 1];
                        }
                    }
                    const eCommerce = eCommerceList.find(eCommerce => eCommerce.code === connectedPartner);
                    if(eCommerce != undefined && (connectionName == 'NA' || !eCommerce.data.find(data => data.connectionName == connectionName))){
                        eCommerce.isShowing = true;
                        eCommerce.data.push({
                            id: data.id,
                            data: null,
                            errorMessage,
                            fileName,
                            connectionName,
                            created_at: data.created_at
                        });
                    }
                })
                let date = new Date(data.created_at).toLocaleTimeString("en-us", options);
                data.created_at_formatted = date == 'Invalid Date' ? data.created_at : date;
            });

            setECommerceList(eCommerceList);
            setIsUserIDFetched(true);
            setUserIDData(response);
        }
        catch(e){
            console.log(`error in fetching ${userid}`, e);
            setIsUserIDError(true);
        } 
        setLoader(false);
    };

    const download = url => {
        const a = document.createElement('a')
        a.href = url
        // a.download = url.split('/').pop()
        a.download = url
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }
    
    useEffect(() => {
        getUserIDData();
    },[]);

    return (
        <div>
            <div className="heading-div">
                <div className="heading-div-left">
                    <div className="navigation-path">
                        <div className="navigation-path-2"> 
                            <span className='navigation-path-clickable' onClick={() => changeRoute('home')}>Statement</span>
                            {
                                <span className={`${isUserID ? 'navigation-path-fade' : 'navigation-path-clickable'}`} onClick={() => {if(isIDDetail || isHistory){changeRoute('userid')}}}>&nbsp;/ {userid}</span>
                            }
                            {
                                (isHistory || isIDDetail) && <span className={`${isHistory ? 'navigation-path-fade' : 'navigation-path-clickable'}`} onClick={() => {if(isIDDetail){changeRoute('history')}}}>&nbsp;/ History</span>
                            }
                            {
                                isIDDetail && <span className='navigation-path-fade'>&nbsp;/ {id}</span>
                            }
                        </div>
                        <div className="navigation-path-1 navigation-path-back" onClick={() => changeRoute()}>
                            <img src={require("./images/left-arrow-1.png")} alt="back_icon" className='back-icon'/>
                            <span>Back</span>
                        </div>
                    </div>
                    <div className="account-name">{userid}</div>
                </div>
                {
                    !isUserIDError && !isIDDetail && (
                        <div className={`export-csv-btn`} onClick={() => {isHistory ? changeRoute('userid') : changeRoute('history');}}>
                            { isHistory ? 'Hide History' : 'History' }
                        </div>
                    )
                }
                {
                    !isHistory && isShowExcelDownload && (
                        <div className={`export-csv-btn ${false ? 'export-csv-btn-downloading' : ''}`} onClick={() => download(isShowExcelDownload)}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0007 7.21337C11.8238 7.21337 11.6543 7.28361 11.5292 7.40864C11.4042 7.53366 11.334 7.70323 11.334 7.88004V12.6667C11.334 12.8435 11.2637 13.0131 11.1387 13.1381C11.0137 13.2631 10.8441 13.3334 10.6673 13.3334H3.33398C3.15717 13.3334 2.9876 13.2631 2.86258 13.1381C2.73756 13.0131 2.66732 12.8435 2.66732 12.6667V5.33337C2.66732 5.15656 2.73756 4.98699 2.86258 4.86197C2.9876 4.73695 3.15717 4.66671 3.33398 4.66671H8.12065C8.29746 4.66671 8.46703 4.59647 8.59206 4.47144C8.71708 4.34642 8.78732 4.17685 8.78732 4.00004C8.78732 3.82323 8.71708 3.65366 8.59206 3.52864C8.46703 3.40361 8.29746 3.33337 8.12065 3.33337H3.33398C2.80355 3.33337 2.29484 3.54409 1.91977 3.91916C1.5447 4.29423 1.33398 4.80294 1.33398 5.33337V12.6667C1.33398 13.1971 1.5447 13.7058 1.91977 14.0809C2.29484 14.456 2.80355 14.6667 3.33398 14.6667H10.6673C11.1978 14.6667 11.7065 14.456 12.0815 14.0809C12.4566 13.7058 12.6673 13.1971 12.6673 12.6667V7.88004C12.6673 7.70323 12.5971 7.53366 12.4721 7.40864C12.347 7.28361 12.1775 7.21337 12.0007 7.21337ZM14.614 1.74671C14.5463 1.58381 14.4169 1.45436 14.254 1.38671C14.1738 1.35255 14.0878 1.33443 14.0007 1.33337H10.0007C9.82384 1.33337 9.65427 1.40361 9.52925 1.52864C9.40422 1.65366 9.33398 1.82323 9.33398 2.00004C9.33398 2.17685 9.40422 2.34642 9.52925 2.47145C9.65427 2.59647 9.82384 2.66671 10.0007 2.66671H12.394L5.52732 9.52671C5.46483 9.58868 5.41524 9.66242 5.38139 9.74366C5.34754 9.82489 5.33012 9.91203 5.33012 10C5.33012 10.088 5.34754 10.1752 5.38139 10.2564C5.41524 10.3377 5.46483 10.4114 5.52732 10.4734C5.58929 10.5359 5.66303 10.5855 5.74427 10.6193C5.82551 10.6531 5.91264 10.6706 6.00065 10.6706C6.08866 10.6706 6.1758 10.6531 6.25704 10.6193C6.33827 10.5855 6.41201 10.5359 6.47398 10.4734L13.334 3.60671V6.00004C13.334 6.17685 13.4042 6.34642 13.5292 6.47144C13.6543 6.59647 13.8238 6.66671 14.0007 6.66671C14.1775 6.66671 14.347 6.59647 14.4721 6.47144C14.5971 6.34642 14.6673 6.17685 14.6673 6.00004V2.00004C14.6663 1.91292 14.6481 1.82686 14.614 1.74671Z" fill="white"/>
                            </svg>
                            Download Excel
                        </div>
                    )
                }
            </div>
            {
                isUserIDFetched
                    ? (
                        !isHistory
                            ? <PartnersDetail id={id} isUserID={isUserID} isIDDetail={isIDDetail} eCommerceList={eCommerceList} download={download} setIsShowExcelDownload={setIsShowExcelDownload} userIDAccountDetail={userIDAccountDetail} setUserIDAccountDetail={setUserIDAccountDetail} isUserIDFetched={isUserIDFetched} options={options} userIDData={userIDData} setECommerceList={setECommerceList} searchParams={searchParams} baseURL={baseURL}/>
                            : <Outlet context={[userIDData, options, changeRoute, eCommerceList ]}/>
                    )
                    : (
                        <div className='error-div-1'>
                            {
                                isUserIDError ? 'Error in getting data, Please check URL' : ''
                            }
                        </div>
                    )
            }
            { isLoading && <FullPageLoader /> }
        </div>
     );
}
 
export default AccountDetail;